import {Injectable} from '@angular/core';
import { environment } from 'src/environments/environment';
import { CarouselImageApiService } from 'src/modules/carousel-image/services/carousel-image-api-service';

@Injectable()
export class OrganisationCarouselImageApiService extends CarouselImageApiService {
  protected getEndpoint(productId: number) {
    return `organisation-admin/carousel/product-id/${productId}`;
  }
}
